import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "statOuter" }, [
  /*#__PURE__*/_createElementVNode("button", null, "In Vault")
], -1)
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "statOuter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state === 'Vault')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["card flex justify-center", { 'card-selected': _ctx.selected }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect1 && _ctx.toggleSelect1(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.nft.externalMetadata.image,
            alt: _ctx.nft.onchainMetadata.data.name
          }, null, 8, _hoisted_1),
          _hoisted_2
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.state === 'Wallet')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["card flex justify-center", { 'card-selected': _ctx.selected }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect2 && _ctx.toggleSelect2(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.nft.externalMetadata.image,
            alt: _ctx.nft.onchainMetadata.data.name
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected')))
            }, "Stake")
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}